import { Background, BorderSize, Foreground, Stroke } from '@front/sharedcomponents/Styles';
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "primary";
    ButtonType["High"] = "high";
    ButtonType["Mid"] = "mid";
    ButtonType["Low"] = "low";
    ButtonType["Secondary"] = "secondary";
    ButtonType["Buy"] = "buy";
    ButtonType["Sell"] = "sell";
    ButtonType["SellSecondary"] = "sell_secondary";
})(ButtonType || (ButtonType = {}));
export const ButtonTypeClass = {
    [ButtonType.Primary]: `${Background.Primary} ${Foreground.Primary} ${BorderSize.None}`,
    [ButtonType.High]: `${Background.High} ${Foreground.Primary} ${BorderSize.None}`,
    [ButtonType.Mid]: `${Background.Mid} ${Foreground.Primary} ${BorderSize.None}`,
    [ButtonType.Low]: `${Background.Low} ${Foreground.Primary} ${BorderSize.None}`,
    [ButtonType.Secondary]: `${Background.Secondary} ${Foreground.Secondary} ${Stroke.General} ${BorderSize.Solid1}`,
    [ButtonType.Buy]: `${Background.Buy} ${Foreground.Primary} ${BorderSize.None}`,
    [ButtonType.Sell]: `${Background.Sell} ${Foreground.Primary} ${BorderSize.None}`,
    [ButtonType.SellSecondary]: `${Background.Sell} ${Background.Outline} ${Foreground.Primary} ${Stroke.General} ${Stroke.OutlineSell} ${BorderSize.Solid1}`
};
